<template>
  <v-content>
    <v-container fluid>
      <h1 ref="top" class="py-3">Device Status</h1>
      <v-card class="mx-auto">
        <v-layout align-space-around row fill-height style="height:500px">
          <v-flex grow>
            <DeviceStatusMap :parentID="parentID" v-on:error="errorHandler" ref="map" />
          </v-flex>
          <v-flex shrink>
            <DeviceStatusTree @mapFocusBounds="(names) => $refs.map.fitToBoundsByName(names)"
              @mapFocus="(name) => $refs.map.openPopupByName(name)" style="height:100%; max-width:300px" />
          </v-flex>
        </v-layout>
      </v-card>
      <AlarmTable @mapFocus="mapFocus" class="my-4"></AlarmTable>
    </v-container>
  </v-content>
</template>

<script>
import DeviceStatusMap from './DeviceStatusMap.vue'
import DeviceStatusTree from './DeviceStatusTree.vue'
import AlarmTable from './AlarmTable.vue'

export default {
  name: 'DeviceStatus',
  components: { DeviceStatusMap, DeviceStatusTree, AlarmTable },
  data () {
    return {
      error: false,
      parentID: null
    }
  },
  methods: {
    errorHandler (error) {
      this.error = error
    },
    mapFocus (name) {
      this.$refs.top.scrollIntoView({ behavior: 'smooth' })
      this.$refs.map.openPopupByName(name)
    }
  },
  beforeMount () {
    if (this.$route.query.parentid) {
      this.parentID = this.$route.query.parentid
    }
  }
}
</script>
